<script>
    import { Link } from "svelte-navigator";
    let year = new Date().getFullYear()
</script>
<footer>
    <div class="content">
        Copyright {year} by jetnoise.ch
    </div>
</footer>

<style>
    footer {
        background-color: var(--background);
        height: var(--header-footer-height);
        line-height: var(--header-footer-height);
        text-align: center;
        position: absolute;
        width: 100%;
        bottom: 0;
    }
</style>